interface NavigationScrollProps {
    children: JSX.Element
}

const NavigationScroll = ({children}: NavigationScrollProps) => {
    return children || null
};


export default NavigationScroll;
